export default {
  '请求': {
    '加载中': '読み込み中',
    '请求失败': 'リクエストに失敗しました',
    '登录已过期': 'セッションの有効期限が切れました',
    '网络连接失败': 'ネットワーク接続に失敗しました',
    '请重新登录': '再度ログインしてください',
    '没有权限访问': 'アクセス権限がありません',
    '请求的资源不存在': 'リソースが見つかりません',
    '服务器错误': 'サーバーエラー',
    '网络错误': 'ネットワークエラー',
    '刷新成功': '更新しました',
    '获取中': '取得中......',
    '账号下线': 'アカウントがオフラインです',
    '功能已禁用': '機能は無効です',
  },
  '导航': {
    '首页': 'ホーム',
    '选妃': '選ぶ',
    '认证': '認証',
    '影院': '動画',
    '个人': 'マイページ',
  },
  '首页': {
    '注册': '登録',
    '影片': '動画',
    '女团': 'ガールズ',
    '热门城市': '人気都市：',
    '经理预订': 'マネージャー予約',
    '看更多': 'もっと見る',
    '身份验证': '認証済み',
    '身高': '身長',
    '胸围': 'バスト',
    '服务城市': '対応都市：',
  },
  '女团': {
    '女团': 'ガールズ',
    '选妃': '選ぶ',
    '身份验证': '認証済み',
    '身高': '身長',
    '胸围': 'バスト',
    '服务城市': '対応都市:',
    '注册': '登録',
    '请联系顾问或接待员': 'アドバイザーまたは受付にご連絡ください',
  },
  '登录': {
    '登录会员视窗': '会員ログイン',
    '请输入用户名': 'ユーザー名を入力',
    '请输入密码': 'パスワードを入力',
    '登录': 'ログイン',
    '没有账号马上注册': 'アカウントをお持ちでない方は登録',
    '登录成功': 'ログインしました',
    '登录注册': 'ログイン / 登録',
    '登录可享受更多服务': 'ログインでもっと多くのサービスを！',
  },
  '注册': {
    '注册': '登録',
    '登录': 'ログイン',
    '请输入用户名': 'ユーザー名を入力',
    '用户名规则': '6〜20文字の英数字',
    '请输入密码': 'パスワードを入力',
    '密码规则': '6〜16文字の英数字',
    '请输入验证码': '認証コードを入力',
    '验证码规则': '4桁の英数字を入力',
    '请输入邀请码': '招待コードを入力',
    '邀请码规则': '代理店の招待コードを入力',
    '同意协议': '18歳以上で、登録規約に同意します',
    '立即注册': '今すぐ登録',
    '注册中': '登録中...',
    '已有账号马上登录': 'アカウントをお持ちの方はログイン',
    '注册成功': '登録完了！',
    '注册失败': '登録失敗：',
    '验证码错误': '認証コードが正しくありません',
    '请同意注册条款': '登録規約に同意してください',
    '用户名已存在': 'ユーザー名は既に使用されています',
    '邀请码无效': '招待コードが無効です',
  },
  '抢单': {
    '今日收益': '本日の収益',
    '余额': '残高',
    '订单': '注文',
    '开始抢单': '注文を取る',
    '当前等级': '現在の等級：',
    '提现': '出金',
    '在线客服': 'オンラインサポート',
    '充值': '入金',
    '幸运任务': 'ラッキー任務',
    '幸运订单': 'ラッキー注文',
    '幸运订单提示': 'おめでとうございます！高報酬のラッキー注文です',
    '恭喜获得幸运订单': 'ラッキー注文を獲得！',
    '提交订单': '注文を提出',
    '未完成订单提示': '未完了の注文があります。先に支払いを完了してから新しい注文を取得してください',
    '正在获取订单': '注文を取得中...',
    '抢单时间': '取得時間：',
    '订单号': '注文番号',
    '订单总额': '注文合計',
    '佣金': '手数料',
    '商品单价': '単価',
    '预计收入': '見込み収入',
    '确认支付': '支払いを確認',
    '确认付款': '支払いを確定',
    '支付处理中': '支払い処理中...',
    '取消': 'キャンセル',
    '去查看': '確認する',
    '暂无可用订单': '利用可能な注文がありません',
    '正在加载用户信息': 'ユーザー情報を読み込み中...',
    '今日抢单已达上限': '本日の取得上限に達しました',
    '余额不足无法获取订单': '残高不足のため注文を取得できません',
    '获取订单失败': '注文の取得に失敗しました',
    '支付成功': '支払い完了',
    '支付失败': '支払いに失敗しました',
    '支付失败请重试': '支払いに失敗しました。再度お試しください',
    '请完成任务单后进入': '任務を完了してから入ってください',
    '请设置收款卡': '受取先を設定してください',,
    '当前余额': '現在の残高',
    '还需缴纳': '追加支払い',
  },
  '我的': {
    '我的页面': 'マイページ',
    '钻石': 'ダイヤモンド',
    '信誉分': '信用スコア',
    '开通专属会员': '専用会員を開通',
    '开启一次日期不限': '一度開通すれば日付制限なし',
    '提现': '出金',
    '历史订单': '注文履歴',
    '充值记录': '入金履歴',
    '提现记录': '出金履歴',
    '添加钱包地址': 'ウォレットアドレスを追加',
    '邀请码': '招待コード：',
    '余额': '残高',
    '退出登陆': 'ログアウト',
  },
  '会员': {
    '会员等级': '会員等級：',
    '普通等级': '一般',
    '当前等级': '現在の等級',
    '立即开通': '今すぐ開通',
    '免费说明': '（無料動画視聴）（無料マッチング）',
    '所需投资': '必要投資額',
    '佣金': '手数料',
    '订单': '注文',
    '加入': '参加 >>',
  },
  '充值': {
    '充值': '入金',
    '当前余额': '現在の残高',
    '余额': '残高：',
    '个': '',
    '充值金额': '入金額',
    '请输入充值金额': '入金額を入力',
    '快速选择金额': 'クイック選択',
    '确认': '確認',
    '提示': 'ヒント',
    '金额错误': '金額が正しくありません',
    '立即充值': '今すぐ入金',
    '提交成功': '提出完了、審査をお待ちください',
  },
  '提现': {
    '提现': '出金',
    '兑换积分': 'ポイント換金',
    '最大提款金额': '最大出金額',
    '资金密码': '資金パスワード',
    '余额': '残高：',
    '个': '',
    '钱包地址': 'ウォレットアドレス：',
    '请选择提款地址': '出金先を選択',
    '暂无绑定地址': '紐付け先がありません。先に登録してください',
    '提交': '提出',
    '通知': '通知：',
    '单笔最大提现': '1、1回あたりの最大出金額:',
    '单笔最低提现': '2、1回あたりの最低出金額：',
    '检查姓名账号': '3、氏名と出金口座をご確認ください',
    '注意提款费用': '4、出金手数料にご注意ください',
    '请填写正确的金额': '正しい金額を入力してください',
    '当前余额': '現在の残高',
    '提现金额': '出金額',
    '请输入提现数量': '出金額を入力',
    '立即提现': '今すぐ出金',
    '交易密码': '取引パスワード',
    '请输入交易密码': '取引パスワードを入力',
    '请先设置提现密码': '先に出金パスワードを設定してください',
  },
  '绑卡': {
    '添加钱包地址': 'ウォレットアドレスを追加',
    '钱包地址信息': 'ウォレットアドレス情報',
    '请输入支付卡信息': 'ウォレットアドレス情報を入力',
    '加密货币类型': '暗号資産の種類',
    '请选择加密货币类型': '暗号資産の種類を選択',
    '钱包地址': 'ウォレットアドレス',
    '请输入钱包地址': 'ウォレットアドレスを入力',
    '绑卡说明': 'お客様の資金安全のため、本名を登録し出金パスワードを設定してください。氏名が口座名義と一致しない場合、出金できません。',
    '确定绑卡': '紐付けを確定',
    '绑卡提示': 'ヒント:大手銀行に紐付けてください。変更が必要な場合はオンラインサポートへご連絡ください',
    '请先设置姓名': '氏名を設定してからウォレットアドレスを登録してください！',
    '已绑定不可修改': '出金先は登録済みです。変更はサポートへご連絡ください',
  },
  '订单历史': {
    '订单历史': '注文履歴',
    '数据为空': 'データなし',
    '订单号': '注文番号：',
    '已完成': '完了',
    '处理中': '処理中',
    '完成订单': '注文を完了',
    '订单金额': '注文金額：',
    '佣金': '手数料：',
    '创建时间': '作成日時：',
    '上一页': '前へ',
    '下一页': '次へ',
    '获取失败': '注文履歴の取得に失敗しました',
    '获取失败重试': '注文履歴の取得に失敗しました。再度お試しください',
    '未知': '不明',
    '完成成功': '注文が完了しました！',
    '完成失败': '注文完了に失敗：',
    '完成失败重试': '注文完了に失敗しました。再度お試しください',
    '请输入支付密码': '支払いパスワードを入力',
    '请先设置支付密码': '先に支払いパスワードを設定してください',
  },
  '入金记录': {
    '标题': '入金履歴',
    '数据为空': 'データなし',
    '认证结果': '審査結果',
    '下单积分': '注文ポイント：',
    '下单时间': '注文日時：',
    '结算时间': '精算日時：',
    '待审核': '審査中',
    '已通过': '承認済み',
    '已拒绝': '却下',
    '暂无数据': 'データなし',
  },
  '提现记录': {
    '标题': '出金履歴',
    '数据为空': 'データなし',
    '待审核': '審査中',
    '审核成功': '審査通過',
    '审核退回': '審査却下',
    '未知状态': '不明な状態',
    '金额': '金額：',
    '说明': '説明：',
    '提交时间': '提出日時：',
    '审核时间': '審査日時：',
    '已通过': '承認済み',
    '已拒绝': '却下',
    '暂无数据': 'データなし',
  },
  '资料': {
    '基本信息': '基本情報',
    '头像': 'アバター',
    '姓名': '氏名',
    '未设置': '未設定',
    '性别': '性別',
    '男': '男性',
    '女': '女性',
    '未知': '不明',
    '设定': '設定',
    '账号信息': 'アカウント情報',
    '更改登录密码': 'ログインパスワードを変更',
    '设定支付密码': '支払いパスワードを設定',
    '退出登录': 'ログアウト',
    '设置': '設定',
    '登录密码': 'ログインパスワード',
    '资金密码': '資金パスワード',
    '提现密码已设置': '出金パスワードは設定済みです。変更はサポートへご連絡ください',
    '已设置': '設定済み',
    '修改真实姓名': '本名を変更',
    '请输入真实姓名': '本名を入力',
    '真实姓名说明': '口座安全のため、本名はウォレット情報と一致する必要があります',
    '提交': '提出',
    '请勿重复设置': '重複して設定しないでください！',
    '修改登录密码': 'ログインパスワードを変更',
    '设置资金密码': '資金パスワードを設定',
    '保存': '保存',
    '旧密码': '現在のパスワード',
    '请输入旧密码': '現在のパスワードを入力',
    '新密码': '新しいパスワード',
    '请输入新密码': '新しいパスワードを入力',
    '确认密码': 'パスワード確認',
    '请再次输入新密码': '新しいパスワードを再入力',
    '请填写完整': 'すべて入力してください！',
    '两次密码不一致': 'パスワードが一致しません',
    '性别修改': '性別を変更',
    '个人报表': '個人レポート',
    '任务金额积分': '任務金額（ポイント）',
    '盈利公式': '利益計算式 : 当選金額 - 任務金額',
    '任务金额': '任務金額',
    '充值金额': '入金額',
    '金额': '金額',
    '中奖金额': '当選金額',
    '个人情报': '個人情報',
    '身高': '身長:',
    '胸围': 'バスト：',
    '收费区间': '料金帯：',
    '系统公告': 'システムお知らせ',
  },
  '客服': {
    '联系客服': 'サポートに連絡',
    '在线客服': 'オンラインサポート',
    '暂无客服': 'サポートは現在利用できません',
    '联系': '連絡',
    '服务时间': '年中無休・24時間対応',
  },
  '影院': {
    '影院': 'シネマ',
    '全部': 'すべて',
    '最高分': '高評価',
    '播放': '再生 :',
    '次播放': '回再生',
    '热门推荐': '人気おすすめ',
    '播放次数': '再生:',
    '请充值后观看': '入金後に動画をご視聴ください',
  },
  '语言切换器': {
    '切换语言': '言語を切り替え',
    '语言': '言語',
  },
}
